import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'chatFilter',
  // pure: false
})
export class ChatPipe implements PipeTransform {

  transform(messages: Array<any>, filter): any[] {
    if (filter === undefined) {return messages; }

    return messages.filter( message => {

        if (message.timeSent >= filter.startDate && message.timeSent <= filter.endDate && this.hasSearchMatch(filter.searchText, message)) {
            return true;
        }
        return false;
    });
   }

   hasSearchMatch(text, message) {
    if (text === '') { return true; }
    if (message.text === null || message.text === undefined) { return false; }
    if (message.text.toLowerCase().includes(text.toLowerCase())) { return true; }
    if (message.userId !== null && message.userId !== undefined) { return message.userId.username.includes(text) ? true : false; }
    if (message.customerId !== null && message.customerId !== undefined) {
        return message.customerId.name.toLowerCase().includes(text.toLowerCase()) ? true : false;
    }
    return false;
   }

}
